$ = require('jquery')

# require('jScrollPane/script/jquery.jscrollpane')
# require('jScrollPane/script/jquery.mousewheel')
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar')

module.exports =
	init: (payload) ->
		{$target} = payload

		# custom scrollbar on boxes
		if $('html').hasClass('no-touch')
			$target.find('.b-videos__wrap, .c-accessories__scroll, .b-compare--line .b-compare__list').each(->
				$this = $(@)

				$this.mCustomScrollbar(
					axis: 'x'
				)
			)



// WEBPACK FOOTER //
// ./src/js/components/scrollbar.coffee